
import { useState } from 'react';
import Card from '../../../components/base/Card';

export default function Testimonials() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      name: 'Priya Sharma',
      location: 'Mumbai, Maharashtra',
      rating: 5,
      text: 'Absolutely amazing experience! Booked my Mumbai to Dubai flight at ₹18,999 when other sites were charging ₹25,000+. The booking process was instant and customer service was exceptional. Highly recommended!',
      image: 'https://readdy.ai/api/search-image?query=professional%20Indian%20businesswoman%20smiling%20confidently%2C%20modern%20office%20background%2C%20corporate%20attire%2C%20natural%20lighting%2C%20successful%20entrepreneur%20portrait%2C%20professional%20headshot%20photography&width=150&height=150&seq=testimonial1&orientation=squarish',
      flightRoute: 'Mumbai → Dubai',
      savings: '₹6,000 saved'
    },
    {
      name: 'Rajesh Kumar',
      location: 'Delhi, NCR',
      rating: 5,
      text: 'I travel frequently for business and MaxJourneys has become my go-to platform. Their prices are consistently lower than competitors and the 24/7 support is fantastic. Saved over ₹50,000 this year alone!',
      image: 'https://readdy.ai/api/search-image?query=professional%20Indian%20businessman%20in%20suit%2C%20confident%20smile%2C%20modern%20corporate%20environment%2C%20executive%20portrait%2C%20business%20professional%20headshot%2C%20natural%20office%20lighting&width=150&height=150&seq=testimonial2&orientation=squarish',
      flightRoute: 'Delhi → Bangalore (Monthly)',
      savings: '₹50,000+ saved annually'
    },
    {
      name: 'Anjali Patel',
      location: 'Ahmedabad, Gujarat',
      rating: 5,
      text: 'Booked our family vacation to Goa through MaxJourneys. Got amazing deals on flights for 6 people and the entire process was smooth. Customer support helped us with seat selection too. Perfect service!',
      image: 'https://readdy.ai/api/search-image?query=happy%20Indian%20mother%20with%20warm%20smile%2C%20casual%20comfortable%20clothing%2C%20home%20setting%20background%2C%20family-oriented%20portrait%2C%20natural%20lighting%2C%20friendly%20and%20approachable%20expression&width=150&height=150&seq=testimonial3&orientation=squarish',
      flightRoute: 'Ahmedabad → Goa (Family of 6)',
      savings: '₹12,000 saved'
    },
    {
      name: 'Vikram Singh',
      location: 'Jaipur, Rajasthan',
      rating: 5,
      text: 'As a travel blogger, I book flights frequently. MaxJourneys consistently offers the best rates and their instant confirmation feature is a lifesaver. Never had any issues with bookings or refunds.',
      image: 'https://readdy.ai/api/search-image?query=young%20Indian%20travel%20blogger%20with%20camera%2C%20adventurous%20spirit%2C%20outdoor%20setting%2C%20creative%20professional%20portrait%2C%20natural%20lighting%2C%20explorer%20and%20storyteller%20vibe&width=150&height=150&seq=testimonial4&orientation=squarish',
      flightRoute: 'Multiple destinations',
      savings: 'Consistent best rates'
    },
    {
      name: 'Meera Reddy',
      location: 'Hyderabad, Telangana',
      rating: 5,
      text: 'Needed to change my flight dates due to emergency. MaxJourneys support team handled everything within minutes without any hassle. This level of service is rare in the travel industry. Truly impressed!',
      image: 'https://readdy.ai/api/search-image?query=professional%20Indian%20woman%20in%20business%20casual%20attire%2C%20confident%20and%20friendly%20demeanor%2C%20modern%20workspace%20background%2C%20successful%20career%20woman%20portrait%2C%20natural%20professional%20lighting&width=150&height=150&seq=testimonial5&orientation=squarish',
      flightRoute: 'Hyderabad → Chennai',
      savings: 'Free date change'
    },
    {
      name: 'Arjun Kapoor',
      location: 'Pune, Maharashtra',
      rating: 5,
      text: 'Booked my honeymoon flights to London through MaxJourneys. Got business class tickets at economy rates from other platforms! The surprise upgrade made our trip even more special. Thank you team!',
      image: 'https://readdy.ai/api/search-image?query=happy%20Indian%20groom%20in%20wedding%20attire%20smiling%20broadly%2C%20celebratory%20background%2C%20joyful%20expression%2C%20traditional%20Indian%20wedding%20photography%2C%20natural%20lighting%2C%20festive%20atmosphere&width=150&height=150&seq=testimonial6&orientation=squarish',
      flightRoute: 'Mumbai → London (Business Class)',
      savings: '₹80,000 saved on upgrade'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-yellow-100 text-yellow-800 rounded-full text-sm font-semibold mb-4">
            <i className="ri-star-fill mr-2"></i>
            4.9/5 Average Rating
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What Our Travelers Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Over 1 million happy customers have saved money and enjoyed seamless flight booking experiences with MaxJourneys. Here's what they have to say about our service.
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.slice(currentSlide, currentSlide + 3).map((testimonial, index) => (
              <Card key={currentSlide + index} hover className="text-center">
                <div className="p-8">
                  <div className="flex justify-center mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                    ))}
                  </div>
                  
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-20 h-20 rounded-full mx-auto mb-4 object-cover object-top"
                  />
                  
                  <h4 className="text-xl font-bold text-gray-900 mb-2">{testimonial.name}</h4>
                  <p className="text-sm text-gray-500 mb-4">{testimonial.location}</p>
                  
                  <div className="bg-blue-50 rounded-lg p-3 mb-4">
                    <p className="text-sm font-semibold text-blue-800 mb-1">{testimonial.flightRoute}</p>
                    <p className="text-xs text-green-600 font-bold">{testimonial.savings}</p>
                  </div>
                  
                  <p className="text-gray-700 italic leading-relaxed">
                    "{testimonial.text}"
                  </p>
                </div>
              </Card>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-xl text-gray-600"></i>
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line text-xl text-gray-600"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {[...Array(Math.ceil(testimonials.length / 3))].map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index * 3)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  Math.floor(currentSlide / 3) === index ? 'bg-blue-600' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Save on Your Next Flight?</h3>
            <p className="text-gray-600 mb-6">Join over 1 million satisfied customers and experience the best flight booking service in India.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => {
                  const searchSection = document.getElementById('flight-search');
                  if (searchSection) {
                    searchSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-bold rounded-lg transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-flight-takeoff-line mr-2"></i>
                Book Your Flight
              </button>
              <button className="px-8 py-3 border-2 border-blue-600 text-blue-600 font-bold rounded-lg hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-phone-line mr-2"></i>
                Call +91 9700644857
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
